import { action, observable, computed } from 'mobx';
import { getExchangeUrl } from '@/utils/location';
import Axios from 'axios';
import SocketClient from '@/utils/socketClient';
import { API, WEBSOCKET_URL_MARKET, WEBSOCKET_URL_USER } from '../config/api';
import WebsocketInstance from '@/models/injection/websocketInstance';

export interface CoinsPrecisionList {
  [coin: string]: number;
}
export interface CoinsLogo {
  coin: string;
  coinName: string;
  logo: string;
}
export default class Coin {
  // marketSocket: SocketClient; // for 'sub_ticker', 'sub_mark_price', 'sub_kline'

  // 、、现货
  @observable symbolList: any[]; // 现货交易对配置列表

  @observable pairSets: any[]; // 类型

  @observable priceComputed: any; // 汇率

  @observable coinsConfig: any[]; // 币种配置

  @observable pairAll: any[]; // 全部币对列表 下拉列表
  @observable coinsLogo: CoinsLogo[]; // 币种图片全称配置

  @observable maxUsdtWithdrawAmountOneDay: number; // 实名每天提现限额

  @observable noKycMaxUsdtWithdrawAmountOneDay: number; // 未实名每天提现限额

  @observable allTicker: any[]; // 所有币对行情

  constructor() {
    this.pairSets = [];
    this.symbolList = []; // symbol: LTC_USDT

    this.priceComputed = null;
    this.maxUsdtWithdrawAmountOneDay = 0;
    this.noKycMaxUsdtWithdrawAmountOneDay = 0;
    this.coinsConfig = [];
    this.pairAll = [];
    this.coinsLogo = [];
    this.allTicker = [];
    //this.marketSocket = WebsocketInstance(WEBSOCKET_URL_MARKET, 'MARKET');
  }

  // 币种列表[]
  @computed get coinList() {
    return this.coinsConfig.map(item => ({
      coin: item.coinType,
      coinUrl: item.config[0].coinConfigVO.logosUrl,
      coinFullName: item.config[0].coinConfigVO.coinFullName,
      config: item.config,
      supportDeposit: item.supportDeposit,
      supportWithdraw: item.supportWithdraw,
    }));
  }

  // 全币种列表[]
  @computed get coinsList() {
    return this.coinsConfig.map(item => ({
      coin: item.coinType,
    }));
  }

  // 币种列表{}
  @computed get coinsConfigObj() {
    const res = {};
    this.coinsConfig.forEach(item => {
      res[item.coinType] = item.config;
    });
    return res;
  }

  // 币种精度
  @computed get coinsPrecisionList(): CoinsPrecisionList {
    const res = {};
    this.coinsConfig?.forEach(item => {
      res[item.coinType] = item.config[0].coinConfigVO.maxPrecision;
    });

    return res;
  }

  // 币种全称
  @computed get coinNamesMap() {
    const res = {};
    this.coinsLogo.forEach(item => {
      res[item.coin] = item.coinName;
    });
    return res;
  }

  // 币种图片
  @computed get coinlogosUrls() {
    const res = {};

    this.coinsLogo.forEach(item => {
      res[item.coin] = item.logo;
    });
    return res;
  }

  @action.bound
  setAllTicker(data: any) {
    this.allTicker = data;
  }

  @action.bound
  setNoKycMaxUsdtWithdrawAmountOneDay(data: any) {
    this.noKycMaxUsdtWithdrawAmountOneDay = data;
  }

  @action.bound
  setMaxUsdtWithdrawAmountOneDay(data: any) {
    this.maxUsdtWithdrawAmountOneDay = data;
  }

  @action.bound
  setSymbolList(data: any) {
    this.symbolList = data;
  }

  @action.bound
  setPairSets(data: any) {
    this.pairSets = data;
  }

  @action.bound
  setPriceComputed(data: any) {
    this.priceComputed = data;
  }

  @action.bound
  setCoinsConfig(data: any) {
    this.coinsConfig = data;
  }

  @action.bound
  setPairAll(data: any) {
    this.pairAll = data;
  }
  @action.bound
  setCoinsLogo(data: CoinsLogo[]) {
    this.coinsLogo = data;
  }

  @action.bound
  async fetchSymbolList() {
    const result: any = await Axios.get(getExchangeUrl().symbolList);
    if (result) {
      this.setSymbolList(result);
    }
  }

  @action.bound
  async fetchPairSets() {
    const result: any = await Axios.get(getExchangeUrl().setList);
    if (result) {
      this.setPairSets(result);
    }
  }

  @action.bound
  async fetchCoinsConfig() {
    const result: any = await Axios.get(getExchangeUrl().coinsList);
    if (result) {
      const { configs, maxUsdtWithdrawAmountOneDay, noKycMaxUsdtWithdrawAmountOneDay } = result;
      this.setCoinsConfig(configs);
      this.setMaxUsdtWithdrawAmountOneDay(maxUsdtWithdrawAmountOneDay);
      this.setNoKycMaxUsdtWithdrawAmountOneDay(noKycMaxUsdtWithdrawAmountOneDay);
    }
  }

  @action.bound
  async fetchPairAll() {
    const result: any = await Axios.get(getExchangeUrl().symbolaAll);
    if (result) {
      this.setPairAll(result);
    }
  }

  @action.bound
  async fetchCoinsLogo() {
    const result: any = await Axios.get(getExchangeUrl().coinsLogo);
    if (result) {
      this.setCoinsLogo(result);
    }
  }
}
